import { __styles, mergeClasses, shorthands } from '@griffel/react';
import { tokens, typographyStyles } from '@fluentui/react-theme';
export const dialogContentClassNames = {
  root: 'fui-DialogContent'
};
/**
 * Styles for the root slot
 */
const useStyles = /*#__PURE__*/__styles({
  root: {
    Bmxbyg5: "f5zp4f",
    sshi5w: "f1nxs5xn",
    B7ck84d: "f1ewtqcl",
    Ijaq50: "faunodf",
    nk6f5a: "f88nxoq",
    Br312pm: "fwpfdsa",
    Bw0ie65: "fsyjsko",
    z8tnut: "fr4fn7s",
    z189sj: ["f171n1a0", "f1jwbs5a"],
    Byoj8tv: "f1ean75l",
    uwmqm3: ["f1jwbs5a", "f171n1a0"],
    B6of3ja: "fxlnl9e",
    t21cq0: ["ffs23cn", "f1v5tmjd"],
    jrapky: "f2uu7rc",
    Frg6f3: ["f1v5tmjd", "ffs23cn"],
    Bahqtrf: "fk6fouc",
    Be2twd7: "fkhj508",
    Bhrd7zp: "figsok6",
    Bg96gwp: "f1i3iumi"
  }
}, {
  d: [".f5zp4f{overflow-y:auto;}", ".f1nxs5xn{min-height:32px;}", ".f1ewtqcl{box-sizing:border-box;}", ".faunodf{-ms-grid-row:2;grid-row-start:2;}", ".f88nxoq{-ms-grid-row-span:2;grid-row-end:2;}", ".fwpfdsa{-ms-grid-column:1;grid-column-start:1;}", ".fsyjsko{-ms-grid-column-span:4;grid-column-end:4;}", ".fr4fn7s{padding-top:var(--strokeWidthThick);}", ".f171n1a0{padding-right:var(--strokeWidthThick);}", ".f1jwbs5a{padding-left:var(--strokeWidthThick);}", ".f1ean75l{padding-bottom:var(--strokeWidthThick);}", ".fxlnl9e{margin-top:calc(var(--strokeWidthThick) * -1);}", ".ffs23cn{margin-right:calc(var(--strokeWidthThick) * -1);}", ".f1v5tmjd{margin-left:calc(var(--strokeWidthThick) * -1);}", ".f2uu7rc{margin-bottom:calc(var(--strokeWidthThick) * -1);}", ".fk6fouc{font-family:var(--fontFamilyBase);}", ".fkhj508{font-size:var(--fontSizeBase300);}", ".figsok6{font-weight:var(--fontWeightRegular);}", ".f1i3iumi{line-height:var(--lineHeightBase300);}"]
});
/**
 * Apply styling to the DialogContent slots based on the state
 */
export const useDialogContentStyles_unstable = state => {
  const styles = useStyles();
  state.root.className = mergeClasses(dialogContentClassNames.root, styles.root, state.root.className);
  return state;
};
//# sourceMappingURL=useDialogContentStyles.styles.js.map